import {Page} from "../../../Common/Component/Page/Page";
import {Card, Col, Form, FormControl, InputGroup, Row} from "react-bootstrap";
import {LoginLogo} from "../../../Common/Component/Logo/LoginLogo";
import {useContext, useState} from "react";
import {LoadingButton} from "../../../Common/Component/Loading/LoadingButton";
import LoginService from "../LoginService";
import Notify from "../../../Common/Notify/Notify";
import {Link, useNavigate} from "react-router-dom";
import {UserContext} from "../../../Common/Context/UserContext";


export default function LoginPage() {

    const [isLoading, setIsLoading] = useState(false);
    const [username, setUsername] = useState(null);
    const [password, setPassword] = useState(null);
    const navigate = useNavigate();
    const user = useContext(UserContext);

    const doLogin = async (e) => {

        e.preventDefault();
        setIsLoading(true);
        try {
            const loginService = new LoginService();
            const userResult = await loginService.doLogin(username, password);
            user.reloadUser(userResult.user);
            Notify.success("Você entrou!");
            navigate("/");
        } catch (e) {
            // eslint-disable-next-line default-case
            switch (e.response.status) {
                case 401:
                    return Notify.error('Usuário ou senha inválidos!');
                case 404:
                    return Notify.error('Serviço indisponível no momento!');
            }
            Notify.error('Falha ao autenticar', e);
        } finally {
            setIsLoading(false);
        }
        return false;
    }

    return <Page>

        <LoginLogo/>

        <Card className="col-sm-12 col-md-6 col-xl-4 offset-xl-4 offset-md-3 p-0">
            <Card.Header as="h5" className="text-center">
                Entrar
            </Card.Header>


            <Card.Body>
                <Form onSubmit={doLogin}>

                    <Form.Group className="mb-3" controlId="email">
                        <Form.Label>E-mail</Form.Label>
                        <InputGroup className="mb-3">
                            <FormControl name="login-email" required
                                         type="email" placeholder="E-mail de autenticação"
                                         onChange={e => setUsername(e.target.value)}/>
                            <InputGroup.Text>
                                <i className="bi bi-envelope-fill"/>
                            </InputGroup.Text>
                        </InputGroup>
                    </Form.Group>


                    <Form.Group className="mb-3" controlId="password">
                        <Form.Label>Senha</Form.Label>
                        <InputGroup className="mb-3">
                            <FormControl required name="password" type="password"
                                         placeholder="Senha"
                                         onChange={e => setPassword(e.target.value)}/>
                            <InputGroup.Text>
                                <i className="bi bi-lock-fill"/>
                            </InputGroup.Text>
                        </InputGroup>
                    </Form.Group>


                    <div className="d-grid gap-2">
                        <LoadingButton isLoading={isLoading} title="Entrar no sistema"
                                       text="Entrar"/>
                    </div>
                </Form>
                <Row className="mt-3">
                    <Col sm={12} md={12} style={{textAlign: 'left'}}>
                        <Link to="/recuperar-senha">Esqueceu sua senha?</Link>
                    </Col>
                </Row>

            </Card.Body>

        </Card>
    </Page>
}
